import { ValidateQuotationDto } from "@/types/api/api-types";
import { DeliveryFormData } from "@/types/forms/home/cotationDeliveryForm.form";

type Props = {
  data: DeliveryFormData;
};

export const validateCotationPayload = ({ data }: Props) => {
  const payload: ValidateQuotationDto = {
    city: data.city,
    email: data.email,
    companyName: data.company,
    firstName: data.firstName,
    lastName: data.lastName,
    postalCode: data.postalCode ?? "",
    street: data.street,
    stateOrProvinceCode: data.stateOrProvinceCode,
    billingEntityId: data.billingEntityId,
    pickUpLocationId: data.pickUpLocationId,
    phone: data.phone,
    comment: data.comment || "",
    cotationWoodBox: data.woodBoxes.map((woodBox) => ({
      bottleQuantity: woodBox.bottleQuantity,
      boxQuantity: woodBox.boxQuantity,
      bottleVolume: woodBox.bottleVolume,
    })),
    deliveryContent: data.deliveryContent.map((deliveryContent) => ({
      wineName: deliveryContent.wineName,
      year: deliveryContent.year,
      alcoholPercent: deliveryContent.alcoholPercent,
      volume: deliveryContent.volume,
      color: deliveryContent.color,
      numberOfBottles: deliveryContent.quantity,
      unitPrice: deliveryContent.price,
    })),
    newFilesId: data.newFilesId,
    removedFilesId: data.removedFilesId,
    insurance: data.insurance,
    express: data.express,
    reference: data.reference,
  };

  return payload;
};
